module.exports = __webpack_public_path__ + "store/img/essentials-placeholder.3aa82e8a.svg";